<template>
  <div class="tabs-container">
    <DxTabs 
      :data-source="tabs" 
      :selected-index.sync="selectedIndex"
      @option-changed="onTabChanged"
      :item-template="tabTemplate"
      orientation="vertical"
    />
    <div v-if="selectedIndex === 0" class="tab-content" >
      <GridDrepturiCustom/>
    </div>
    <div v-if="selectedIndex === 1" class="tab-content">
      <GridMeniuCustom/>
    </div>
  </div>
</template>
<script>
import { DxTabs } from 'devextreme-vue/tabs';
import GridDrepturiCustom from './GridDrepturiCustom.vue';
import GridMeniuCustom from './GridMeniuCustom.vue';


export default {
  components: {
    GridDrepturiCustom,
    GridMeniuCustom,
    DxTabs,
  },
  data() {
    return {
      tabs: [
        { text: 'Drepturi' },
        { text: 'Meniu' },
      ],
      selectedIndex: 0,
    };
  },
  methods: {
    onTabChanged(e) {
      this.selectedIndex = e.component.option('selectedIndex');
    },
    tabTemplate(itemData, itemIndex, itemElement) {
      return  `<div">${itemData.text}</div>`;
    },
  },
};
</script>
<style scoped>
.tabs-container {
  display: flex;
  height: 100%;
}

.tabs {
  width: 200px; /* Adjust as needed */
  border-right: 1px solid #ddd;
  background-color: #f4f4f4;
}

.tab-content {
  flex: 1;
  padding: 16px;
  overflow: auto;
}

.tab-content > * {
  margin-bottom: 16px; /* Adjust spacing between components */
}
</style>
